module.exports = __webpack_public_path__ + "edc2fc5a160c47739e6438aebe18e7eb.png";